import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { TranslatePipe } from '@ngx-translate/core';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Prevent NG0100 caused by setTranslation() firing onTranslationChange synchronously
// during Angular's CD cycle (e.g. from field-wrapper merging dynamic field labels).
// setTranslation() clears lastKey on all translate pipe instances mid-pass, so
// Angular's checkNoChanges pass sees a different value than the first pass.
// Language changes via translate.use() still trigger onLangChange which correctly
// re-evaluates all pipes in the next CD cycle outside of the current pass.
const _origTransform = TranslatePipe.prototype.transform;
TranslatePipe.prototype.transform = function(this: any, query: string, ...args: any[]) {
  const result = _origTransform.call(this, query, ...args);
  if (this.onTranslationChange) {
    this.onTranslationChange.unsubscribe();
    this.onTranslationChange = undefined;
  }
  return result;
};

declare global {
  interface String {
    formatUnicorn(value: string): string;
  }
}
/**
 * String formatting a la StackOverflow:
 * https://stackoverflow.com/a/18234317
 */
String.prototype.formatUnicorn = String.prototype.formatUnicorn ||
  function() {
    'use strict';
    let str = this.toString();
    if (arguments.length) {
      const t = typeof arguments[0];
      let key;
      const args = ('string' === t || 'number' === t) ?
        Array.prototype.slice.call(arguments)
        : arguments[0];

      for (key in args) {
        if (args.hasOwnProperty(key)) {
          str = str.replace(new RegExp('\\{' + key + '\\}', 'gi'), args[key]);
        }
      }
    }

    return str;
  };

if (environment.production) {
  enableProdMode();
  window.console.log = () => { }
  window.console.group = () => { }
  window.console.groupCollapsed = () => { }
  window.console.groupEnd = () => { }
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
